import React from 'react'
import Bredcom from '../Bredcrumb/Main'
import Book from '../../components/Menhome/Book'
import Img from '../../assets/images/background/banner-image-2.jpg';


function Main() {
  return (
    <>
      <Bredcom
        subtitle="Резервирай"
        title="Запази маса"
        Img={Img}
      />
      
      <Book />
    </>
  )
}

export default Main